const def = 'cache-';

export const hasData = cache => sessionStorage.hasOwnProperty(def+cache);

export const setData = (cache, value) => sessionStorage.setItem(def+cache, value);

export const deleteData = cache => sessionStorage.removeItem(def+cache)

export const getData = cache => sessionStorage.getItem(def+cache);
